import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, isSuperMaster } from '../../utils/auth';

const ProtectedRoute = ({ children, requireSuperMaster = false }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/admin/login" replace />;
  }
  if (requireSuperMaster && !isSuperMaster()) {
    return <Navigate to="/admin" replace />;
  }
  return children;
};

export default ProtectedRoute;
